export default __webpack_public_path__ + "static/media/extensive.94349ad0.svg";